import { SearchQuery } from '~/features/advanced-search/types';
import { pilot } from '~/services/serviceInstances';

interface Request {
  query: SearchQuery;
  clauseName: string;
}

export const updateClause = async ({ query, clauseName }: Request) => {
  return await pilot.patch(`/ai-command-center/update/?clause=${clauseName}`, {
    search_query: query,
  });
};
